import appLocaleData from 'react-intl/locale-data/af';
import enMessages from '../locales/af-AF';

const AfLang = {
    messages: {
        ...enMessages
    },
    locale: 'af-AF',
    data: appLocaleData
};
export default AfLang;